import { graphql } from 'react-relay';

export const partnerDiscountQuery = graphql`
  query benefitRefundPartnerQuery($utmCampaign: String!) {
    refundPartner(partnerId: $utmCampaign) {
      partnerName
      partnerId
      feeRate
      defaultFeeRate
      discountRate
    }
  }
`;

export const landingModalQuery = graphql`
  query benefitLandingModalQuery($utmSource: String!, $utmCampaign: String) {
    landingModal(utmSource: $utmSource, utmCampaign: $utmCampaign) {
      id
      name
      manager
      active
      utmCampaign
      utmSource
      imagePath
      backgroundColor
      userEvent
      buttons
      startAt
      endAt
    }
  }
`;
